import createLucideIcon from '../createLucideIcon';

const ArrowDownSquare = createLucideIcon('ArrowDownSquare', [
  [
    'rect',
    {
      width: '18',
      height: '18',
      x: '3',
      y: '3',
      rx: '2',
      ry: '2',
      key: '1m3agn',
    },
  ],
  ['polyline', { points: '8 12 12 16 16 12', key: '14qdon' }],
  ['line', { x1: '12', x2: '12', y1: '8', y2: '16', key: '10p56q' }],
]);

export default ArrowDownSquare;
